import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCrop from 'react-image-crop';
import { ButtonV2 } from '@zola/zola-ui';

import './CropModal.less';

// TODO: should add minWidth and minHeight to stop crop box from being made smaller than the
// minimum width or height requirements (approximately 1200x1200)

class CropModal extends Component {
  constructor(props) {
    super(props);
    const { aspectRatio, img } = props;

    const imageRatio = img.width / img.height;
    const imageIsPortrait = imageRatio < 1;

    // Our crop previews are currently all squares (BE adds white space around the original image).
    // For our calculations, consider the width & height as percentages of the displayed square.
    let height;
    let width;

    // Base the default crop size off of the image's smallest dimension
    if (imageIsPortrait) {
      width = 100 * Math.min(aspectRatio, imageRatio);
      height = width / aspectRatio;
    } else {
      height = 100 / Math.max(aspectRatio, imageRatio);
      width = height * aspectRatio;
    }

    this.state = {
      // Default cropper values (in percentage)
      crop: {
        unit: '%',
        aspect: aspectRatio, // aspect ratio of the crop zone, not the image
        width,
        height,
        x: (100 - width) / 2,
        y: (100 - height) / 2,
      },
      // Resulting crop values that will be passed to our callback
      pixelCrop: {
        height: 0, // crop height in pixels,
        width: 0, // crop width in pixels
        x: 0, // crop x-coordinate in pixels
        y: 0, // crop y-coordinate in pixels
      },
      imgLoaded: false,
      submitted: false,
    };

    this.handleImageLoaded = this.handleImageLoaded.bind(this);
    this.handleCrop = this.handleCrop.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleImageLoaded(img, pixelCrop) {
    // pixelCrop needs to be set so that we have the width/height of the image in
    // in pixels, since we don't know these values until the image has loaded
    this.setState({
      pixelCrop,
      imgLoaded: true,
    });
  }

  handleCrop(crop, pixelCrop) {
    this.setState({
      crop, // update the crop object which is used by ReactCrop
      pixelCrop, // update the pixelCrop object which will be used by onCropSelect callback in handleSubmit
    });
  }

  handleSubmit() {
    const { onCropSelect } = this.props;
    const { pixelCrop } = this.state;
    // set submitted state to true to disable submit button, so that it cannot be clicked again while saving cropped image
    this.setState({ submitted: true }, () => onCropSelect(pixelCrop));
  }

  render() {
    const { imageUrl, minimal } = this.props;
    const { imgLoaded, crop, submitted } = this.state;

    return (
      <div id={minimal ? 'cropper' : 'crop-modal'}>
        {!minimal && (
          <div className="modal-header">
            <h3 className="modal-title">Crop Photo</h3>
          </div>
        )}
        <div className={minimal ? 'cropper' : 'modal-body'}>
          <div className="crop-wrapper">
            <ReactCrop
              src={imageUrl}
              onComplete={this.handleCrop}
              onImageLoaded={this.handleImageLoaded}
              crop={crop}
              keepSelection
              onChange={this.handleCrop}
            />
          </div>
          <div className="save-crop">
            <ButtonV2 onClick={this.handleSubmit} disabled={submitted || !imgLoaded}>
              {submitted ? 'Uploading...' : 'Save'}
            </ButtonV2>
          </div>
        </div>
      </div>
    );
  }
}

CropModal.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  onCropSelect: PropTypes.func.isRequired,
  aspectRatio: PropTypes.number,
  minimal: PropTypes.bool,
};

export default CropModal;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/CropModal/CropModal.jsx